export default __webpack_public_path__ + "static/media/leaf-1.5e8698a7.png";